function tokenise(s: string | undefined) {
  return s
    ?.toLocaleLowerCase()
    .split(/\s+/)
    .filter((token) => token.length);
}

export function tokeniseQuery(query: string) {
  return tokenise(query);
}

export function matchesSearch(
  queryTokens: string[],
  tokenisedCandidate: (string | undefined)[],
) {
  // TODO This should be tokenisedCandidate: TokenisedCandidate once implemented
  return tokenisedCandidate.some((candidateToken) =>
    queryTokens.some((queryToken) =>
      tokenise(candidateToken)?.some((t) => t.startsWith(queryToken)),
    ),
  );
}

export type TokenisedCandidate = {};

/*type Match = {
  isExact?: boolean,
}*/

export function matchList(
  queryTokens: string[],
  tokenisedCandidates: TokenisedCandidate[],
) {}
